import deleteAsync from './deleteAsync';
import createAsync from './createAsync';
import updateAsync from './updateAsync';
import getAsync from './getAsync';
import getListAsync from './getListAsync';
import getDataTableAsync from './getDataTableAsync';
// imports

export default apiUrl => ({
  deleteAsync: deleteAsync(apiUrl),
  createAsync: createAsync(apiUrl),
  updateAsync: updateAsync(apiUrl),
  getAsync: getAsync(apiUrl),
  getListAsync: getListAsync(apiUrl),
  getDataTableAsync: getDataTableAsync(apiUrl),
  // exports
});
